import { render, staticRenderFns } from "./AddProductConfirmModal.vue?vue&type=template&id=2cdd972e"
import script from "./AddProductConfirmModal.vue?vue&type=script&lang=js"
export * from "./AddProductConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports